import axios from 'axios';
import i18n from './../../../i18n';
//Example i18n.t('vue.error_getting_lots')
import router from './../../routes';
import env from '../../../env';
import Vue from "vue";
import helpers from "../../../helpers";
import Locale from '../../../vue-i18n-locales.generated';

const lang = localStorage.getItem('language') || 'ua';
const $t = (item) => Locale[lang][item];

const CancelToken = axios.CancelToken;
let axiosCancel = null;

const state = {
    channel: null,
    techChat: [],
    channelCategories: [],
    onePersonalChat: null,
    personalChats: [],
    chatsWithMe: [],
    chatsAll: [],
    messages: {},
    lastMessageId: null,
    searchMessages: {},
    searchMembers: null,
    courses: null,
    socketHash: null,
    showProfileActive: false,
    channelId: null,
    personalChannelInterlocutorId: null,
    noConnection: false,
    sidebarStateLeft: false,
    sidebarStateRight: false,
    localStorageAvailable: false,
    schoolGroups: [],
    studentGroups: [],
    modals: {
        chooseGroups: {
            isActive: false
        }
    },
    components: {
        resetPassword: {
            error: false,
        },
        mainChat: {
            scrollButton: false,
            scrollable: false,
            sentFile: {},
            fileLoader: {},
            fileError: {},
            isUploaded: false,
            key: 0,
            positionBottom: false,
            editMessage: {
                text: '',
                messageId: null,
                changed: false,
                student_groups_ids: null
            },
            pinnedMessage: {
                text: '',
                messageId: null,
                author: {
                    first_name: null,
                    last_name: null,
                    patronymic: null,
                },
                created: null,
            },
            techChatGroups: null
        },
        rightPanel: {
            key: 0,
            prefix: false,
        },
        notification: {
            text: '',
            isActive: false
        }
    }
};

const mutations = {
    'SET_CHANNEL_CATEGORIES'(state, categories) {
        state.channelCategories = categories;
    },
    'SET_TECH_CHAT'(state, techChat) {
        state.techChat = techChat;
    },
    'SET_SCHOOL_STUDENTS_GROUPS'(state, groups) {
        state.schoolGroups = groups;
    },
    'SET_STUDENT_GROUPS'(state, groups) {
        state.studentGroups = groups;
    },
    'SET_MODAL_STATE'(state, { modal, prop, value }) {
        Vue.set(state.modals[modal], prop, value)
    },
    'SET_PREFIX'(state, prefix) {
        state.components.rightPanel.prefix = prefix
    },
    'USER_AT_BOTTOM'(state, position) {
        state.components.mainChat.positionBottom = position
    },
    'SET_CHATS_WITH_ME'(state, data) {
        state.chatsWithMe = data
    },
    'SET_NOTIFICATION_ALERT'(state, { text = '', isActive = false }) {
        state.components.notification.text = text;
        state.components.notification.isActive = isActive;
    },
    'SET_LAST_MESSAGE_ID'(state, id) {
        state.lastMessageId = id
    },
    'SET_FOR_COMPONENT'(state, { page, field, value }) {
        state.components[page][field] = value
    },
    'SET_SEARCH_MESSAGES'(state, data) {

        let messagesWithId = [];

        if (Object.keys(data).length !== 0) {
            data.forEach(item => {
                messagesWithId[item.id] = item
            });
            state.searchMessages = helpers.removeFalsy(messagesWithId)
        } else {

            state.searchMessages = data
        }
    },
    'SET_SEARCH_MEMBERS'(state, data) {
        state.searchMembers = data
    },
    'SET_PERSONAL_CHATS'(state, chats) {
        let allChats = chats.filter(item => !item.is_group);
        if (state.onePersonalChat && !state.onePersonalChat.total_messages_count) allChats.push(state.onePersonalChat);
        state.personalChats = helpers.getUnique(allChats, 'id');
    },
    'ADD_PERSONAL_CHATS'(state, newChats) {
        let chats = state.personalChats;
        newChats.forEach(chat => chats.push(chat));
        state.personalChats = helpers.getUnique(chats, 'id')
    },
    'SET_ONE_PERSONAL_CHAT'(state, chat) {
        state.onePersonalChat = chat;
        let personalChats = state.personalChats;
        if (!personalChats.find(item => item.id == chat.id) && chat) personalChats.push(chat);
        state.personalChats = helpers.getUnique(personalChats, 'id');
    },
    'SET_COURSES'(state, courses) {
        state.courses = courses;
    },
    'SET_ALL_CHATS'(state, chats) {
        let chatsArr = state.chatsAll
        if (chats.length) chatsArr = [...chatsArr, ...chats];
        state.chatsAll = chatsArr;
    },
    'SET_SOCKET_HASH'(state) {
        state.socketHash = Math.random();
    },
    'SET_SHOW_PROFILE_ACTIVE'(state, showProfileActive) {
        state.showProfileActive = showProfileActive;
    },
    'SET_CHANNEL'(state, channel) {
        state.channel = channel;
    },
    'SET_CHANNEL_ID'(state, channelId) {
        state.channelId = channelId;
    },
    'SET_PERSONAL_CHANNEL_INTERLOCUTOR_ID'(state, personalChannelInterlocutorId) {
        state.personalChannelInterlocutorId = personalChannelInterlocutorId;
    },
    'SET_MESSAGES'(state, messages) {
        let messagesWithId = [];
        if (Array.isArray(messages)) {
            messages.forEach(item => {
                messagesWithId[item.id] = item
            });
        }
        if (messages && typeof messages === 'object' && messages.constructor === Object) {
            messagesWithId = messages
        }

        state.messages = helpers.removeFalsy(messagesWithId);
    },
    'SET_ONE_MESSAGE'(state, message) {
        let messages = state.messages;
        messages[message.id] = message;
        state.messages = helpers.removeFalsy(messages)
    },
    'CLEAR_MESSAGES'(state) {
        state.messages = {}
    },
    'SET_NO_CONNECTION'(state, noConnection) {
        state.noConnection = noConnection;
    },
    'TOGGLE_SIDEBAR_LEFT'(state, sidebarStateLeft) {
        state.sidebarStateLeft = sidebarStateLeft;
        if (state.sidebarStateLeft) state.sidebarStateRight = false
    },
    'TOGGLE_SIDEBAR_RIGHT'(state, sidebarStateRight) {
        state.sidebarStateRight = sidebarStateRight
        if (state.sidebarStateRight) state.sidebarStateLeft = false
    },
    'SET_LOCAL_STORAGE_AVAILABLE'(state, localStorageAvailable) {
        state.localStorageAvailable = localStorageAvailable;
    },
    SET_SENDER(state, comment) {
        if (state.channel === null) return;
        if (state.channel.author_members.hasOwnProperty(comment.sender)) return;
        if (state.channel.members.hasOwnProperty(comment.sender)) return;

        const newAuthors = { ...state.channel.author_members };

        const member = state.channel.members.find((member) => {
            return member && member.id === comment.sender;
        });

        newAuthors[comment.sender] = member;

        state.channel.author_members = helpers.removeFalsy(newAuthors);
    },
};

const actions = {
    lock_scroll_request: ({ commit }) => {
        commit("SET_FOR_COMPONENT", { page: 'mainChat', field: 'scrollable', value: false });
        setTimeout(() => {
            commit("SET_FOR_COMPONENT", { page: 'mainChat', field: 'scrollable', value: true });
        }, 3000);
    },
    members_online_status: ({ commit }, params) => {
        return new Promise((resolve, reject) => {
            axios.get(env.api_url + 'members_online_status/', {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('token'),
                },
                params: {
                    lang: localStorage.getItem('language'),
                    'channel_ids': params
                }
            })
                .then((response) => {
                    resolve(response.data.data);
                }, (err) => {
                    console.log(err);
                    reject(err);
                });
        });
    },
    getWhiteboardStatus: ({ commit, state }) => {
        return new Promise((resolve, reject) => {
            axios.post(env.api_url + 'whiteboard/room/', {
                'channel_id': state.channelId,
                'room_name': state.channel.name ? state.channel.name : state.channelId
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('token'),
                }
            })
                .then(res => {
                    // console.log(res, "res");
                    if (res.status === 201) {
                        const params = {
                            text: $t('whiteboard_room_success'),
                            isActive: true,
                        };
                        commit('SET_NOTIFICATION_ALERT', params);
                        resolve(res.data.data);
                        return;
                    }
                    throw new Error('whiteboard status not 201');
                    // if ( res.data.success && res.data.data ) {
                    //     resolve( res.data.data );
                    // }
                })
                .catch((err) => {
                    // console.log(err);
                    const params = {
                        text: $t('whiteboard_room_fail'),
                        isActive: true,
                    };
                    commit('SET_NOTIFICATION_ALERT', params);
                    reject(err);
                });
        });
    },
    getWhiteboardLink: ({ state }, roomId) => {
        return new Promise((resolve, reject) => {
            axios.get(env.api_url + `whiteboard/room/${state.channelId}/${roomId}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('token'),
                }
            })
                .then(res => {
                    console.log(res, "res");
                    if (res.data.success && res.data.data) {
                        console.log(res.data.data.room_url, "room_url 1");
                        console.log(res.data.room_url, "room_url 2");
                        window.open(res.data.data.room_url, '_blank');
                    }
                }, err => {
                    reject(err);
                    console.log(err);
                });
        });
    },
    showProfileActive: ({ commit }, params) => {
        commit('SET_SHOW_PROFILE_ACTIVE', params);
    },
    scrollChatSection: ({ commit }, milliseconds) => {
        setTimeout(() => {
            let mainChatSection = document.getElementById("main-chat-section"),
                chatHeight = document.querySelector('#mainChat').scrollHeight;

            let unreads = document.getElementsByClassName('unread');
            mainChatSection.scrollTop = typeof unreads[0] !== 'undefined' ? unreads[0].offsetTop - 90 : chatHeight - 10;
        }, milliseconds ? milliseconds : 1);
    },
    addMessageToChannel: ({ commit, dispatch, state, rootState }, msgObj) => {
        if (typeof msgObj !== 'undefined') {

            commit('SET_ONE_MESSAGE', msgObj);

            if (msgObj.sender === rootState.common.userData.id && !state.components.mainChat.positionBottom) {
                let params = {
                    'channel_id': msgObj.channel_id,
                    'query': {
                        'offset': 0,
                        'limit': 20,
                        'id__lte': msgObj.id,
                        'lang': localStorage.getItem('language')
                    }
                };

                dispatch('channel_messages', params);
                dispatch('setAllMessagesRead', {
                    'channel_id': state.channelId,
                    'lang': localStorage.getItem('language')
                });
            }
        }
    },
    channels: ({ commit, rootState }, ids) => {
        return new Promise((resolve, reject) => {
            axios.get(env.api_url + 'channels/',
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    },
                    params: {
                        channels_ids: ids ? ids.join() : null,
                        lang: localStorage.getItem('language')
                    }
                }).then((response) => {
                    if (response && typeof response.data.success !== 'undefined') {
                        if (!ids) {
                            commit('SET_COURSES', response.data.data.channels);
                            commit('SET_PERSONAL_CHATS', response.data.data.private_channels.filter(chat => chat.members[0] && chat.members[0].id !== rootState.common.userData.id));

                            let techChat = response.data.data.channels.filter(chat => chat.is_tech);
                            commit('SET_TECH_CHAT', techChat);
                            commit('SET_ALL_CHATS', [...response.data.data.channels, ...response.data.data.private_channels.filter(chat => chat.members[0] && chat.members[0].id !== rootState.common.userData.id)]);
                            commit('SET_CHANNEL_CATEGORIES', response.data.data.channel_categories);
                        }

                        if (ids && ids.length) {
                            commit('ADD_PERSONAL_CHATS', response.data.data.private_channels.filter(chat => chat.members[0] && chat.members[0].id !== rootState.common.userData.id));
                        }

                        resolve(response.data.data.private_channels.filter(chat => chat.members[0] && chat.members[0].id !== rootState.common.userData.id));
                    }
                }, (err) => reject(err));
        });
    },
    channel: ({ commit, dispatch, state }, id) => {
        if (axiosCancel !== null) {
            axiosCancel.cancel('cancel before fetch channel');
        }

        axiosCancel = null;

        if (!id) {
            commit('SET_CHANNEL', null);
        } else {
            axiosCancel = CancelToken.source();
            return new Promise((resolve, reject) => {
                axios.get(env.api_url + 'channel/' + String(id) + '/',
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json',
                            'Authorization': 'Bearer ' + localStorage.getItem('token'),
                        },
                        params: {
                            lang: localStorage.getItem('language')
                        },
                        cancelToken: axiosCancel.token,
                    }).then((response) => {
                        if (response && typeof response.data.success !== 'undefined') {
                            resolve(response);
                            let res = response.data.data;
                            commit('SET_CHANNEL', res);
                            commit('SET_CHANNEL_ID', res.id);
                            commit('SET_SEARCH_MESSAGES', {});
                            commit('SET_SOCKET_HASH');
                            commit('CLEAR_MESSAGES');
                            commit('SET_LAST_MESSAGE_ID', res.last_message_id);

                            let pin = res.pinned_message_data,
                                pinnedMessage = {
                                    messageId: (pin && pin.id) || null,
                                    text: (pin && pin.text) || '',
                                    pin: pin || false,
                                    author: {
                                        first_name: (pin && pin.author.first_name) || null,
                                        last_name: (pin && pin.author.last_name) || null,
                                        patronymic: (pin && pin.author.patronymic) || null,
                                    },
                                    created: (pin && pin.created) || null
                                };
                            commit("SET_FOR_COMPONENT", {
                                page: 'mainChat',
                                field: 'pinnedMessage',
                                value: pinnedMessage
                            });

                            let params = {
                                'channel_id': id,
                                'query': {
                                    'offset': 0,
                                    'limit': 11,
                                    'lang': localStorage.getItem('language')
                                },
                            };

                            if (state.channel.first_unread_id !== 0 && state.channel.first_unread_id !== state.channel.last_message_id) {
                                params.query['id__gte'] = state.channel.first_unread_id
                                delete params.query['id__lte'];
                            } else {
                                params.query['id__lte'] = state.channel.last_message_id
                                delete params.query['id__gte'];
                            }

                            dispatch('lock_scroll_request');

                            dispatch('channel_messages', params).then(response => {
                                let ids = [];

                                if (typeof response.data.results !== 'undefined') {
                                    Object.values(response.data.results).forEach(item => {
                                        ids.push(+item.id);
                                    });
                                }
                                if (ids.length !== 0) {
                                    let messages = {
                                        'params': {
                                            'chat_message_ids': ids,
                                            'lang': localStorage.getItem('language')
                                        },
                                        'channel_id': state.channel.id
                                    };

                                    dispatch('setMessagesRead', messages);
                                }
                                if (params.query.id__lte) dispatch('scrollChatSection');

                                commit("SET_FOR_COMPONENT", { page: 'mainChat', field: 'scrollable', value: true });

                            }, err => {
                                console.log(err, "err")
                            });
                        } else {
                            commit('SET_CHANNEL', null);
                        }
                    }, (err) => {
                        console.clear();
                        console.log(err);
                        commit('SET_CHANNEL', null);
                        let params = { text: 'Something went wrong', show: true };
                        commit('SET_NOTIFICATION_ALERT', params);
                        reject(err)
                    })
            });
        }
    },
    personal_channel: ({ commit, dispatch, state }, id) => {
        if (axiosCancel !== null) {
            axiosCancel.cancel('cancel before fetch personal_channel');
        }

        axiosCancel = null;

        if (!id) {
            commit('SET_CHANNEL', null);
        } else {
            axiosCancel = CancelToken.source();
            return new Promise((resolve, reject) => {
                axios.get(env.api_url + 'personal_channel/' + String(id) + '/',
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json',
                            'Authorization': 'Bearer ' + localStorage.getItem('token'),
                        },
                        params: {
                            lang: localStorage.getItem('language')
                        },
                        cancelToken: axiosCancel.token,
                    }).then((response) => {
                        if (response && typeof response.data.success !== 'undefined') {
                            resolve(response);
                            commit('SET_CHANNEL', response.data.data);
                            commit('SET_CHANNEL_ID', response.data.data.id);
                            commit('SET_SEARCH_MESSAGES', {});
                            commit('SET_SOCKET_HASH');
                            commit('CLEAR_MESSAGES');
                            commit('SET_LAST_MESSAGE_ID', response.data.data.last_message_id);
                            commit("SET_FOR_COMPONENT", {
                                page: 'mainChat',
                                field: 'pinnedMessage',
                                value: {}
                            });
                            // let personalChats = state.personalChats;
                            // personalChats.forEach(chat => {if(chat.id === params.channel_id) chat['unread_messages_count'] = 0;});
                            // commit('SET_PERSONAL_CHATS', personalChats);

                            let params = {
                                'channel_id': state.channel.id,
                                'query': {
                                    'offset': 0,
                                    'limit': 10,
                                    'lang': localStorage.getItem('language')
                                },
                            };

                            if (!!state.channel.first_unread_id && state.channel.first_unread_id !== state.channel.last_message_id) {
                                params.query['id__gte'] = state.channel.first_unread_id;
                                delete params.query['id__lte']
                            } else {
                                params.query['id__lte'] = state.channel.last_message_id;
                                delete params.query['id__gte']
                            }

                            dispatch('lock_scroll_request');

                            dispatch('channel_messages', params).then(res => {
                                if (res.data.results.length) {
                                    let ids = [];

                                    Object.values(res.data.results).forEach(item => {
                                        ids.push(+item.id);
                                    });

                                    let messages = {
                                        'params': {
                                            'chat_message_ids': ids,
                                            'lang': localStorage.getItem('language')
                                        },
                                        'channel_id': state.channel.id
                                    };
                                    dispatch('setMessagesRead', messages);
                                }

                                if (params.query.id__lte) dispatch('scrollChatSection');
                                commit("SET_FOR_COMPONENT", { page: 'mainChat', field: 'scrollable', value: true });

                            }, err => console.log(err, "error"));

                            let personalChats = state.personalChats;
                            personalChats = personalChats.filter(item => !item.dummy);
                            commit('SET_PERSONAL_CHATS', personalChats);

                            commit('SET_ONE_PERSONAL_CHAT', response.data.data);
                        } else {
                            commit('SET_ONE_PERSONAL_CHAT', null);
                            commit('SET_CHANNEL', null);
                        }
                    }, (err) => {
                        console.clear();
                        console.log(err);
                        commit('SET_ONE_PERSONAL_CHAT', null);
                        commit('SET_CHANNEL', null);
                        let params = { text: 'Something went wrong', show: true };
                        commit('SET_NOTIFICATION_ALERT', params);
                        reject(err)
                    })
            });
        }
    },
    channel_messages: ({ commit, dispatch }, params) => {
        return new Promise((resolve, reject) => {
            axios.get(env.api_url + 'channel_messages/' + String(params.channel_id) + '/', {
                params: params.query,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('token'),
                }
            }).then((response) => {
                if (response && typeof response.data.success !== 'undefined') {

                    let firstMsg = document.querySelector('.main-chat__item'),
                        mainChatSection = document.getElementById("main-chat-section"),
                        messages = state.messages;

                    if (response.data.data.results.length >= 7) {
                        commit('SET_FOR_COMPONENT', {
                            page: 'mainChat',
                            field: 'scrollButton',
                            value: true
                        });
                    } else if (response.data.data.results.length <= 4) {
                        commit('SET_FOR_COMPONENT', {
                            page: 'mainChat',
                            field: 'scrollButton',
                            value: false
                        });
                    }

                    if (response.data.data.results.some(i => i.id === response.data.data.last_message_id) && response.data.data.results.length <= 4) {
                        dispatch('scrollChatSection', 1000);
                    }

                    if (params.firstRequest && !params.scroll) {
                        mainChatSection.scrollTop = 10;
                    }

                    if (!response.data.data.results.length && (params.query.id__gt || params.query.id__gte)) {
                        dispatch('scrollChatSection');
                    }

                    commit('SET_LAST_MESSAGE_ID', response.data.data.last_message_id);

                    response.data.data.results.forEach((item) => {
                        if (item['attachments'] && item['attachments'][0]) {
                            item['attachment'] = item['attachments'][0];
                            delete item['attachments'];
                        }

                        if (firstMsg) {
                            commit('SET_ONE_MESSAGE', item);
                        } else {
                            commit('SET_ONE_MESSAGE', item)
                        }

                        commit('SET_SENDER', item);
                    });

                    // if scrolling up then stay on last message and not scroll to top
                    if (firstMsg && params['scroll'] === 0) {
                        setTimeout(() => {
                            mainChatSection.scrollTop = firstMsg.offsetTop;
                        }, 1);
                        commit("SET_FOR_COMPONENT", { page: 'mainChat', field: 'scrollable', value: false });

                        setTimeout(() => {
                            commit("SET_FOR_COMPONENT", { page: 'mainChat', field: 'scrollable', value: true });
                        }, 500)
                    }

                    if (params['scroll'] === 1) {
                        dispatch('scrollChatSection');
                    }

                    if (messages instanceof Array) {
                        commit('SET_MESSAGES', messages);
                    }

                    resolve(response.data);

                }
            }, (err) => {
                console.log('error', err);
            });

        }).catch(err => {
            reject({ err, msg: 'No response' });
        })
    },

    search: ({ commit, dispatch, state }, params) => {
        axios.get(env.api_url + 'search_messages/',
            {
                params: params,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('token'),
                }
            }).then((response) => {

                commit('SET_SEARCH_MESSAGES', response.data.chat_messages);

            }, (err) => {
                console.log(err);
                console.log('error');
            })
    },
    searchMembers: ({ commit, dispatch, state }, params) => {
        axios.get(env.api_url + 'search_users/',
            {
                params: params,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('token'),
                }
            }).then((response) => {

                if (response && typeof response.data.success !== 'undefined') {
                    commit('SET_SEARCH_MEMBERS', response.data.data);
                }
            }, (err) => {
                console.log(err);
                console.log('error');
            })
    },
    sendFile:
        ({ commit, state }, form_data) => {
            return new Promise((resolve, reject) => {
                let messages = state.messages;
                for (let pair of form_data.entries()) {
                    if (pair[0] == 'chat_message_id') {
                        messages[pair[1]]['fileState'] = { loader: true }
                    }
                }
                commit("SET_FOR_COMPONENT", { page: 'mainChat', field: 'key', value: state.components.mainChat.key + 1 });
                commit('SET_MESSAGES', messages);

                axios.put(env.api_url + 'attachments/',
                    form_data,
                    {
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                            'Accept': 'application/json',
                            'Authorization': 'Bearer ' + localStorage.getItem('token'),
                        }
                    })
                    .then((response) => {

                        if (response && typeof response.data.success !== 'undefined') {
                            messages[response.data.attachment.chat_message]['attachment'] = {};

                            // TODO: check how to recompute state (bug with cached message.update state)
                            messages[response.data.attachment.chat_message]['attachment'] = response.data.attachment;
                            messages[response.data.attachment.chat_message]['updated'] += ' ';

                            messages[response.data.attachment.chat_message]['fileState'] = {
                                error: false,
                                index: form_data.get('chat_message_id'),
                                loader: false
                            };

                            commit('SET_MESSAGES', messages);
                        }
                        resolve(response);
                    }).catch(err => {
                        reject({ err, msg: 'Ошибка загрузки файла' });
                    });
            })
        },

    setMessagesRead:
        ({ commit }, params) => {
            return new Promise((resolve, reject) => {
                axios.put(env.api_url + 'set_messages_read/',
                    params.params,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json',
                            'Authorization': 'Bearer ' + localStorage.getItem('token'),
                        }
                    }).then((response) => {
                        if (response && typeof response.data.success !== 'undefined') {

                            let courses = state.courses;

                            if (typeof courses !== 'undefined' && courses !== null) {
                                for (let i = 0; i < courses.length; i++) {
                                    if (params.channel_id == courses[i]['id']) {
                                        courses[i].unread_messages_count -= response.data.read_count;
                                    }
                                }
                            }
                            let personalChats = state.personalChats;
                            if (personalChats) {
                                personalChats.forEach(chat => {
                                    if (chat.id === params.channel_id) {
                                        chat['unread_messages_count'] -= response.data.read_count;
                                    }
                                });
                            }

                            commit('SET_COURSES', courses);
                            commit('SET_PERSONAL_CHATS', personalChats);
                        }
                        resolve(response);
                    }).catch(err => {
                        reject(err);
                    });
            })
        },

    setAllMessagesRead:
        ({ commit }, params) => {
            return new Promise((resolve, reject) => {
                axios.put(env.api_url + 'set_all_messages_read/',
                    params,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json',
                            'Authorization': 'Bearer ' + localStorage.getItem('token'),
                        }
                    }).then((response) => {
                        if (response && typeof response.data.success !== 'undefined') {
                            let courses = state.courses;
                            for (let i = 0; i < courses.length; i++) {
                                if (params.channel_id == courses[i]['id']) {
                                    courses[i].unread_messages_count = 0;
                                }
                            }

                            let personalChats = state.personalChats;
                            personalChats.forEach(chat => { if (chat.id === params.channel_id) chat['unread_messages_count'] = 0; });
                            commit('SET_PERSONAL_CHATS', personalChats);
                            commit('SET_COURSES', courses);
                        }
                        resolve(response);
                    }).catch(err => {
                        reject(err);
                    });
            })
        },

    setChannelId:
        ({ commit }, channelId) => {
            commit('SET_CHANNEL_ID', channelId);
        },
    setNoConnection:
        ({ commit }, noConnection) => {
            commit('SET_NO_CONNECTION', noConnection);
        },
    toggleSidebarLeft: ({ commit }, sidebarState) => {
        commit('TOGGLE_SIDEBAR_LEFT', sidebarState);
    },
    toggleSidebarRight: ({ commit }, sidebarState) => {
        commit('TOGGLE_SIDEBAR_RIGHT', sidebarState);
    },
    setLocalStorageAvailable: ({ commit }, localStorageAvailable) => {
        commit('SET_LOCAL_STORAGE_AVAILABLE', localStorageAvailable);
    },
    updateChannelUnreadCounter:
        ({ commit, state }, { channel_id, last_msg_datetime }) => {
            let courses = state.courses;
            for (let i = 0; i < courses.length; i++) {
                if (+channel_id === courses[i]['id'] && courses[i].is_group) {
                    if (typeof courses[i].unread_messages_count === 'undefined') {
                        courses[i]['unread_messages_count'] = 0;
                    }
                    courses[i].unread_messages_count++;
                    break;
                }
            }

            let personalChats = state.personalChats;
            personalChats.forEach(chat => {
                if (chat.id === +channel_id) {
                    chat['last_msg_datetime'] = last_msg_datetime;
                    chat['unread_messages_count']++;
                }
            });
            commit('SET_PERSONAL_CHATS', personalChats);
            commit('SET_COURSES', courses);
        },
    updatePersonalChats: ({ state, commit }, { channel_id, last_msg_datetime }) => {
        let personalChats = state.personalChats;
        personalChats.forEach(chat => {
            if (chat.id === channel_id) {
                chat['last_msg_datetime'] = last_msg_datetime;
            }
        });
        commit('SET_PERSONAL_CHATS', personalChats);
    },
    setSocketHash:
        ({ commit }) => {
            commit('SET_SOCKET_HASH');
        },
    fileLoader: ({ commit }, params) => {
        commit('SET_FOR_COMPONENT', { page: 'mainChat', field: 'fileLoader', value: params });
    },
    setChatsWithMe: ({ commit }, data) => {
        commit('SET_CHATS_WITH_ME', data)
    }
};

const getters = {
    channelMembers: (state, getters, rootState) => {
        let channelMembers = {};
        if (state.channel) {
            for (let key in state.channel.author_members) {
                if (state.channel.author_members.hasOwnProperty(key)) {
                    channelMembers[state.channel.author_members[key]['id']] = state.channel.author_members[key];
                }
            }
        }

        if(rootState.common.userData){
            channelMembers[rootState.common.userData.id] = rootState.common.userData;
        }

        return channelMembers;
    },
    channelCurrentMembers: state => {
        let channelMembers = {};
        if (state.channel) {
            for (let key in state.channel.members) {
                if (state.channel.members.hasOwnProperty(key)) {
                    channelMembers[state.channel.members[key]['id']] = state.channel.members[key];
                }
            }
        }

        return channelMembers;
    },
    channelTeachers: state => {
        if (state.channel) {
            return state.channel.members.filter(member => {
                return member.role === 'owner' || member.role === 'teacher' || member.role === 'admin';
            });
        } else return null;
    },
    channelStudents: state => {
        if (state.channel) {
            return state.channel.members.filter(function (member) {
                return member.role === 'student' || member.role === 'parent' || member.role === 'billing' || member.role === 'student/billing';
            });
        } else return null;

    },
    schoolGroups: state => {
        let groups = [];
        state.schoolGroups.forEach(group => {
            group['selected'] = false;
            groups.push(group)
        });
        return groups;
    },
    courses: state => state.courses,
    personalChats: state => state.personalChats,
    showProfileActive: state => state.showProfileActive,
    channel: state => state.channel,
    channelId: state => state.channelId,
    noConnection: state => state.noConnection,
    sidebarStateLeft: state => state.sidebarStateLeft,
    sidebarStateRight: state => state.sidebarStateRight,
    localStorageAvailable: state => state.localStorageAvailable,
    messages: state => state.messages,
    searchMessages: state => state.searchMessages,
    searchMembers: state => state.searchMembers,
    socketHash: state => state.socketHash,
    lastMessageId: state => state.lastMessageId,
    chatsWithMe: state => state.chatsWithMe,
    channelCategories: state => state.channelCategories,
    modals: state => state.modals,
    studentGroups: state => state.studentGroups,
    techChat: state => state.techChat,
    chatsAll: state => state.chatsAll,
    techChatsIds: state => state.techChat.map(item => item.id),
    pinnedMessage: state => state.components.mainChat.pinnedMessage,
    // components
    notification: state => state.components.notification,
    resetPassword: state => state.components.resetPassword,
    mainChat: state => state.components.mainChat,
    allPrefix: state => state.components.rightPanel.prefix,
};


export default {
    state,
    mutations,
    actions,
    getters
}
